import { post } from '@src/api/sharing';
import { useMutation } from '@tanstack/react-query';

function useCreateShareDashboard() {
  const mutation = useMutation((shareData) => {
    return post(shareData);
  });

  return mutation;
}

export default useCreateShareDashboard;
